import { Col, Input, Row } from "reactstrap"
import { Group } from "../../../../../backoffice/dtos/groups/group";
import { useTranslation } from "react-i18next";

export default function DepartmentEdit(
    {
        isOpen,
        department,
        setDepartment,
        errors,
        toggle
    }: {
        isOpen: boolean;
        department: Group;
        setDepartment: React.Dispatch<React.SetStateAction<Group>>;
        errors: Map<string, string>;
        toggle: () => void;
    }
) {
    const {t} = useTranslation(['department_info','common'])

    return (
        <Row>
            <Col sm={2} className="d-flex align-items-center justify-content-end">
                {t('Name', { ns: 'common' })}*
            </Col>
            <Col>
                <Input value={department.description} onChange={event => setDepartment(ref => ({ ...ref, description: event.target.value }))} />
                {
                    errors && errors.has("name") && <span className="text-danger">{errors.get("name")}</span>
                }
            </Col>
        </Row>
    )
}